import { AES } from "crypto-js";
import Utf8 from "crypto-js/enc-utf8";

const substitutionsAfterEncryption = new Map([
    ["+", "-"],
    ["/", "_"],
]);

const substitutionsBeforeDecryption = new Map([
    ["-", "+"],
    ["_", "/"],
]);

export const encrypt = (plaintext) => {
    const encodedPlaintext = encodeURIComponent(plaintext);
    const encrypted = AES.encrypt(
        encodedPlaintext,
        process.env.REACT_APP_MYTOTALLYSECRETKEY
    ).toString();

    return encrypted.replace(
        /[/]/g,
        (match) => substitutionsAfterEncryption.get(match) ?? match
    );
};

export const decrypt = (cipher) => {
    const toDecrypt = cipher.replace(
        /[_]/g,
        (match) => substitutionsBeforeDecryption.get(match) ?? match
    );

    const decrypted = AES.decrypt(
        toDecrypt,
        process.env.REACT_APP_MYTOTALLYSECRETKEY
    ).toString(Utf8);

    return decodeURIComponent(decrypted);
};